import { axiosInstance } from "../axios";

export const khoTrungTamApi = {
  getPaginate: (params) =>
    axiosInstance.get("/central-warehouse-evaluation/forms", { params }),
  create: (data) =>
    axiosInstance.post("/central-warehouse-evaluation/forms", data),
  getById: (id) =>
    axiosInstance.get(`/central-warehouse-evaluation/forms/${id}`),
  rate: (id, storeCode, data) =>
    axiosInstance.put(
      `/central-warehouse-evaluation/forms/${id}/stores/${storeCode}`,
      data,
    ),
};
